import api from './api';

const moduleService = {
  getModulesByProject: async (projectId, params = {}) => {
    try {
      const response = await api.get(`/furniture-modules/projects/${projectId}/modules`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar módulos:', error);
      throw error;
    }
  },

  getModuleById: async (id) => {
    try {
      const response = await api.get(`/furniture-modules/modules/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar módulo:', error);
      throw error;
    }
  },

  createModule: async (projectId, data) => {
    try {
      const response = await api.post(`/furniture-modules/projects/${projectId}/modules`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar módulo:', error);
      throw error;
    }
  },

  updateModule: async (id, data) => {
    try {
      const response = await api.put(`/furniture-modules/modules/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar módulo:', error);
      throw error;
    }
  },

  deleteModule: async (id) => {
    try {
      const response = await api.delete(`/furniture-modules/modules/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar módulo:', error);
      throw error;
    }
  }
};

export default moduleService;
